import axios from "axios";
import Cookies from "js-cookie";
import refreshAccessToken from "./refresh";

const requestLeaderboardSession = () => {
  const accessToken = Cookies.get("access_token");
  return axios.post(
    `${process.env.REACT_APP_API_URL}/leaderboard/session`,
    {},
    {
      headers: {
        // A visitor who is not logged in sends no token; the API then returns
        // the public leaderboard link.
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
        "Content-Type": "application/json",
      },
    }
  );
};

const openLeaderboard = async () => {
  try {
    const { data } = await requestLeaderboardSession();
    window.location.href = data.redirect_url;
  } catch (err) {
    // Refreshing only makes sense for a logged-in user. Without a refresh token
    // it would fail and send a visitor to /sign-in instead of showing an error.
    if (
      err.response &&
      (err.response.status === 401 || err.response.status === 403) &&
      Cookies.get("refresh_token")
    ) {
      await refreshAccessToken();
      const { data } = await requestLeaderboardSession();
      window.location.href = data.redirect_url;
      return;
    }
    throw err;
  }
};

export default openLeaderboard;
